<template>

  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <!-- <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 v-if="language=='ltr'" class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{texts.meetings}}
          </h3>
          <h3 v-else class="mb-0 text-right" :class="type === 'dark' ? 'text-white': ''">
            {{texts.meetings}}
          </h3>
        </div>
        <div class="col text-right">

        </div>
      </div>
    </div> -->

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  style="color: black;"
                  tbody-classes="list"
                  type=""
                  :data="tableData" >
        <template slot="columns">
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.title}}</th>
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.description}}</th>
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.date}}</th>
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.time}}</th>
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.location}}</th>
          <!-- <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.details}}</th> -->
          <!-- <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.details}}</th> -->
          <!-- <th align="center" style="padding-left: 0.5rem;padding-right: 0rem;"><center><span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #bf2718; color: white;margin-right: 1px;margin-top: 15px;width:50px;">V.H</span></center></th>
          <th align="center" style="padding-left: 0rem;padding-right: 0rem;"><center><span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #E74C3C; color: white;margin-right: 1px;margin-top: 15px;width:50px;">H</span></center></th>
          <th align="center" style="text-align:center;padding-left: 0rem;padding-right: 0rem;">{{texts.findings}}<br><center><span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #F39C12; color: white;margin-right: 1px;width:50px;">M</span></center></th>
          <th align="center" style="padding-left: 0rem;padding-right: 0rem;"><center><span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #F4D03F; color: white;margin-right: 1px;margin-top: 15px;width:50px;">L</span></center></th>
          <th align="center" style="padding-left: 0rem;padding-right: 0rem;"><center><span class="badge badge-pill badge-danger" style="font-size: 10px;background-color: #ffeb14; color: white;margin-right: 1px;margin-top: 15px;width:50px;">V.L</span></center></th> -->

          <!-- <th class="align-items-center">Schedule</th> -->
          <!-- <th>Findings</th> -->
          <th align="center" style="text-align: center;padding-left: 0rem;padding-right: 0rem;">{{texts.details}}</th>
          <!-- <th>Status</th>
          <th>Location</th> -->

        </template>

        <template slot-scope="{row}">


           <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
            <div class="media align-items-center">

              <div class="media-body">
                <span class="name mb-0" style="font-size: 14px;">{{row.title}}</span>

              </div>

            </div>

          </td>

          <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
           <div class="media align-items-center">

             <div class="media-body" style="text-align : center;align-items: center;">
               <span class="name mb-0" style="align-items: center;text-align : center;display:block;font-size: 14px; width: 50ch;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{row.description}}</span>

             </div>

           </div>

         </td>
         <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
          <div class="media align-items-center">

            <div class="media-body">
              <span class="name mb-0" style="font-size: 14px;">{{row.start.split("T")[0].split("-")[2]}}-{{row.start.split("T")[0].split("-")[1]}}-{{row.start.split("T")[0].split("-")[0]}}</span>

            </div>

          </div>

        </td>
        <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
         <div class="media align-items-center">

           <div class="media-body">
             <span class="name mb-0" style="font-size: 14px;">{{row.startend}}</span>

           </div>

         </div>

       </td>
       <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
        <div class="media align-items-center">

          <div class="media-body">
            <span class="name mb-0" style="font-size: 14px;align-items: center;text-align : center;display:block;font-size: 14px; width: 30ch;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{row.location}}</span>

          </div>

        </div>

      </td>


        <!-- <td v-bind:style="[row.postponed ? {'padding-left' : '0rem', 'padding-right' : '0rem', 'width' : '20px', 'padding-top' : '54px'} : {'padding-left' : '0rem', 'padding-right' : '0rem', 'width' : '20px'}]" align="center" >
          <table border=1 frame=void rules=rows >
            <tr v-for="r in row.phases">
              <td align="center" style="padding-left: 0.5rem;padding-right: 0.5rem;">{{r}}</td>
             </tr>
              <div style="width: 15px;" v-if="row.postponed">
 <p style="color: red; font-size: 14px; vertical-align: bottom; "><span style=" font-weight: 600;overflow-wrap: break-word;">Notes: </span>{{row.notes}}</p>
              </div>

          </table>
        </td>

        <td style="padding-left: 0rem;padding-right: 0rem;width : 30px;" align="center">
          <table border=1 frame=void rules=rows>
              <tr v-for="r in row.scheduled_start_dates">
              <td align="center" style="padding-left: 0.5rem;padding-right: 0.5rem;">{{r}}</td>
             </tr>
          </table>
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;width : 30px;" align="center">
          <table border=1 frame=void rules=rows>
              <tr v-for="r in row.actual_start_dates">
              <td align="center" style="padding-left: 0.5rem;padding-right: 0.5rem;">{{r}}</td>
             </tr>
          </table>
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;width : 30px;" align="center">
          <table border=1 frame=void rules=rows>
             <tr v-for="r in row.scheduled_end_dates">
              <td align="center" style="padding-left: 0.5rem;padding-right: 0.5rem;">{{r}}</td>
             </tr>
          </table>
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;width : 30px;" align="center">
          <table border=1 frame=void rules=rows>
              <tr v-for="r in row.actual_end_dates">
              <td align="center" style="padding-left: 0.5rem;padding-right: 0.5rem;">{{r}}</td>
             </tr>
          </table>
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;font-size: 14px;" align="center" >
          {{row.very_high_findings}}
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;font-size: 14px;" align="center" >
          {{row.high_findings}}
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;font-size: 14px;" align="center" >
          {{row.medium_findings}}
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;font-size: 14px;" align="center" >
          {{row.low_findings}}
        </td>
        <td style="padding-left: 0rem;padding-right: 0rem;font-size: 14px;" align="center" >
          {{row.very_low_findings}}
        </td> -->



<!--           <tr style="width: 100%;">
           <th >{{row.business_unit}}</th>
            <td>555 77 854</td>
            </tr>
            <tr>
            <td>3242342342</td>
            </tr> -->
           <!--  <tr>
              <td>555 77 855</td>
              </tr> -->


          <!-- <td> -->
<!--               <a-steps :current="row.current_date" size="small">
                <a-step>

                  <template slot="title">
                    Schedule visit date
                  </template>
                  <span slot="description">{{row.date_1}}</span>
                </a-step>
                <a-step title="Actual visit date" :description="row.date_2" />
                <a-step title="Schedule Audit Date" :description="row.date_3" />
                <a-step title="Actual Audit Date" :description="row.date_4" />

              </a-steps>   -->
<!--               <div v-if="row.delay" style="margin-bottom: -20px;margin-top: 10px;">

                <p style="color: red; font-size: 14px; vertical-align: bottom;"><span style="font-weight: 600;overflow-wrap: break-word;">Notes: </span>Audit was postponed for one week due to month-end based on Mgmt.</p>
              </div> -->

          <!-- </td> -->
          <!-- <td> -->

            <!-- <badge :type="row.statusType" style="font-size: 12px;">{{row.status}}</badge> -->
            <!-- <badge class="badge-dot mr-4" :type="row.statusType"> -->
              <!-- <i :class="`bg-${row.statusType}`"></i> -->
              <!-- <badge type="row.statusType">{{row.status}}</badge> -->

              <!-- <span class="status">{{row.status}}</span> -->
            <!-- </badge> -->
          <!-- </td> -->


        <!--   <td>
            <div>
              <span style="margin-left: 11px;margin-right: 7px;">High</span>
              <span style="margin-left: 13px;margin-right: 12px;">Med</span>
              <span style="margin-left: 9px;margin-right: 7px;">Low</span>
            </div>
            <div class="d-flex align-items-center">
              <span class="badge badge-pill badge-danger" style="font-size: 20px;background-color: #E74C3C; color: white;margin-right: 1px;">{{row.high_findings}}</span>
              <span class="badge badge-pill badge-warning" style="font-size: 20px; background-color: #F39C12;color: white;margin-right: 1px;">{{row.medium_findings}}</span>
              <span class="badge badge-pill badge-danger" style="font-size: 20px; background-color: #F4D03F; color: white;">{{row.low_findings}}</span>
            </div>
          </td> -->

          <!-- <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" align="center">
            <div class="d-flex align-items-center"  style="width: 50%;">

              <button type="button" class="btn btn-primary btn-sm" v-on:click="onClick(row._id)">{{texts.view}}</button>

            </div>
          </td> -->
          <td style="text-align: center;padding-left: 0rem;padding-right: 0rem;" scope="row" >
           <div class="media align-items-center">

             <div class="media-body">
               <button type="button" class="btn btn-primary btn-sm" v-on:click="viewMtng(row)">{{texts.view}}</button>

             </div>

           </div>

         </td>


          <!-- <td class="text-right">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <a class="dropdown-item" href="#">Something else here</a>
              </template>
            </base-dropdown>
          </td> -->

        </template>

      </base-table>
    </div>

  <!--   <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination total="30"></base-pagination>
    </div> -->

  </div>
</template>
<script>
    import store from "@/store";
    import UserService from "@/common/user.service";
    // import styles from "@../../assets/phasesprogress.css"

  export default {
    name: 'meetings-table',

    props: {
      type: {
        type: String
      },
      view : Function,
      title: String,
      tableData : Array
    },

    methods: {
      viewMtng(id) {
        this.$emit('view', id);
      },
        onClick(token) {
          this.$router.push({ name: 'viewdeliverables', params: { token:  token} });
        }
    },
    mounted() {
      let self = this;
    // function onPubnub(msg) {
    //                     self.tableData.push(msg.message);

    //               // for (let i = 0; i < self.tableData.length; i++) {
    //               //   if (self.tableData[i].token === msg.message) {
    //               //     self.tableData[i].hasLocation = true;
    //               //     self.tableData[i].status = 'Received';
    //               //     self.tableData[i].statusType = 'success';
    //               //   }
    //               // }
    //     }

    //    var pubnub = new PubNub({
    //         publishKey: "pub-c-19662d2f-1d79-4568-a018-e352b0af2171",
    //         subscribeKey: "sub-c-9185b126-23bc-11e9-bb27-2e4c7f2c8bda"
    //     });



    //     pubnub.addListener({
    //         status: function(statusEvent) {
    //             if (statusEvent.category === "PNConnectedCategory") {
    //                 // publishSampleMessage();
    //             }
    //         },
    //         message: function(msg) {
    //             console.log(msg.message);
    //             onPubnub(msg);

    //         },
    //         presence: function(presenceEvent) {
    //             // handle presence
    //         }
    //     })
    //     pubnub.subscribe({
    //         channels: ['911_channel']
    //     });

    },
    data() {
      return {
        texts : {
          meetings : UserService.getLanguage() === "rtl" ? "الإجتماعات" : "Meetings",
          register : UserService.getLanguage() === "rtl" ? "تسجيل" : "Register",
          phonenumber : UserService.getLanguage() === "rtl" ? "رقم الهاتف" : "Phone Number",
          title : UserService.getLanguage() === "rtl" ? "العنوان" : "Title",
          newpass : UserService.getLanguage() === "rtl" ? "كلمة السر الجديدة" : "New Password",
          description : UserService.getLanguage() === "rtl" ? "الوصف" : "Description",
          location : UserService.getLanguage() === "rtl" ? "الموقع" : "Location",
          time : UserService.getLanguage() === "rtl" ? "الوقت" : "Time",
          date : UserService.getLanguage() === "rtl" ? "التاريخ" : "Date",
          details : UserService.getLanguage() === "rtl" ? "تفاصيل" : "Details",
          // title : UserService.getLanguage() === "rtl" ? "الإنجاز" : "Progress",
          // businessunit : UserService.getLanguage() === "rtl" ? "وحدات العمل" : "Business Unit",
          // phases : UserService.getLanguage() === "rtl" ? "المراحل" : "Phases",
          // scheduledstartdate : UserService.getLanguage() === "rtl" ? ["تاريخ","البدء المجدول"] : ["Scheduled", "Start Date"],
          // actualstartdate : UserService.getLanguage() === "rtl" ? ["تاريخ","البدء الفعلي"] : ["Actual", "Start Date"],
          // scheduledendate : UserService.getLanguage() === "rtl" ? ["تاريخ","الانتهاء المجدول"] : ["Scheduled","End Date"],
          // actualendate : UserService.getLanguage() === "rtl" ? ["تاريخ","الانتهاء الفعلي"] : ["Actual", "End Date"],
          // findings : UserService.getLanguage() === "rtl" ? "الملاحظات" : "Findings",
          // deliverables : UserService.getLanguage() === "rtl" ? "المخرجات" : "Deliverables",
          view : UserService.getLanguage() === "rtl" ? "عرض" : "View"
        },
        language : UserService.getLanguage() || "ltr"
        // tableData: [
        //   {
        //     img: 'img/theme/bootstrap.jpg',
        //     name: 'Abdallah Barakat',
        //     phone: '0790700926',
        //     status: 'Received',
        //     statusType: 'success',
        //     hasLocation: true,
        //     completion: 60
        //   },
        //   {
        //     img: 'img/theme/bootstrap.jpg',
        //     name: 'Abdallah Barakat',
        //     phone: '0790700926',
        //     status: 'Received',
        //     statusType: 'success',
        //     hasLocation: true,
        //     completion: 60
        //   },
        //   {
        //     img: 'img/theme/bootstrap.jpg',
        //     name: 'Abdallah Barakat',
        //     phone: '0790700926',
        //     status: 'Sent',
        //     statusType: 'warning',
        //     hasLocation: false,
        //     completion: 60
        //   },
        //   {
        //     img: 'img/theme/bootstrap.jpg',
        //     name: 'Abdallah Barakat',
        //     phone: '0790700926',
        //     status: 'Sent',
        //     statusType: 'warning',
        //     hasLocation: false,
        //     completion: 60
        //   },
        //   {
        //     img: 'img/theme/bootstrap.jpg',
        //     name: 'Abdallah Barakat',
        //     phone: '0790700926',
        //     status: 'Sent',
        //     statusType: 'warning',
        //     hasLocation: false,
        //     completion: 60
        //   },
        // ]
      }
    }
  }
</script>
<style>
/*@import "compass/css3";*/

@mixin gray-stripe {
background-size: 35px 35px;
background-color: #EcEcEc;
background-image: -webkit-linear-gradient(-45deg, rgba(255, 255, 255, .4) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .4) 50%, rgba(255, 255, 255, .4) 75%,transparent 75%, transparent);
background-image: -moz-linear-gradient(-45deg, rgba(255, 255, 255, .4) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .4) 50%, rgba(255, 255, 255, .4) 75%,transparent 75%, transparent);
}

@mixin blue-stripe {
background-size: 35px 35px;
background-color: #57aed1;
background-image: -webkit-linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%,transparent 75%, transparent);
background-image: -moz-linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%,transparent 75%, transparent);
}

@mixin green-stripe {
background-size: 35px 35px;
background-color: #8bc53f;
background-image: -webkit-linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%,transparent 75%, transparent);
background-image: -moz-linear-gradient(-45deg, rgba(255, 255, 255, .2) 25%, transparent 25%,transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%,transparent 75%, transparent);
}

@mixin inner-shadow {
-webkit-box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, .2); box-shadow: inset 2px 2px 2px 0px rgba(0, 0, 0, .2);
}
@-webkit-keyframes myanimation {
  from {
    left: 0%;
  }
  to {
    left: 50%;
  }
}

h1 {
 text-align:center;
  font-family: 'PT Sans Caption', sans-serif;
  font-weight: 400;
  font-size: 30px;
  padding: 20px 0;

  color: #777;
}

.checkout-wrap {
  color: #444;
  font-family: 'PT Sans Caption', sans-serif;
  margin: 40px auto;
  max-width: 1200px;
  position: relative;
}
ul.checkout-bar {
  margin: 0 20px;
  li {
    color: #ccc;
    display: block;
    font-size: 16px;
    font-weight: 600;
    padding: 14px 20px 14px 80px;
    position: relative;
    &:before {
      @include inner-shadow;
      background: #ddd;
      border: 2px solid #FFF;
      border-radius: 50%;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      left: 20px;
      line-height: 37px;
      height: 35px;
      position: absolute;
      text-align: center;
      text-shadow: 1px 1px rgba(0, 0, 0, 0.2);
      top: 4px;
      width: 35px;
      z-index: 999;
    }
     &.active {
      color: #8bc53f;
      font-weight: bold;
      &:before {
        background: #8bc53f;
        z-index: 99999;
      }
    }
    &.visited {
      background: #ECECEC;
      color: #57aed1;
      z-index: 99999;
      &:before {
       background: #57aed1;
        z-index: 99999;
      }
    }
    &:nth-child(1) {
      &:before {
        content: "1";
      }
    }
     &:nth-child(2) {
      &:before {
        content: "2";
      }
    }
    &:nth-child(3) {
      &:before {
        content: "3";
      }
    }
     &:nth-child(4) {
      &:before {
        content: "4";
      }
    }
    &:nth-child(5) {
      &:before {
        content: "5";
      }
    }
    &:nth-child(6) {
      &:before {
        content: "6";
      }
    }
  }
  a {
    color: #57aed1;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
  }
}



@media all and (min-width: 800px) {
 .checkout-bar li.active:after {
    -webkit-animation: myanimation 3s 0;
    @include green-stripe;
    @include inner-shadow;
    content:"";
    height: 15px;
    width: 100%;
    left: 50%;
    position: absolute;
    top: -50px;
    z-index: 0;
  }
  .checkout-wrap {
    margin: 80px auto;
  }
  ul.checkout-bar {
  @include inner-shadow;
  @include gray-stripe;
  border-radius: 15px;
  height: 15px;
  margin: 0 auto;
  padding: 0;
  position: absolute;
  width: 100%;
  &:before {
    @include blue-stripe;
    @include inner-shadow;
    border-radius: 15px;
    content: " ";
    height: 15px;
    left: 0;
    position: absolute;
    width: 10%;
  }
   li {
      display: inline-block;
      margin: 50px 0 0;
      padding: 0;
      text-align: center;
      width: 19%;
      &:before {
        height: 45px;
        left: 40%;
        line-height: 45px;
        position: absolute;
        top: -65px;
        width: 45px;
        z-index: 99;
      }
      &.visited {
        background: none;
        &:after {
          @include blue-stripe;
          @include inner-shadow;
          content: "";
          height: 15px;
          left: 50%;
          position: absolute;
          top: -50px;
          width: 100%;
          z-index: 99;
        }
      }
    }
  }
}
</style>
